"use strict";

// Flip card
const cards = document.querySelectorAll(".card-flip");
cards.forEach(function (card) {
    card.addEventListener("click", function () {
        card.classList.toggle("is-flipped");
    });
});
